export default "__VITE_ASSET__CRbq0NME__"